<template>
  <div>
    <h3>Zonas de seguridad</h3>
    <DataTable
      :config="config"
      :data="areasSeguridad"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    >
    </DataTable>

    <modal
      v-model="showModal"
      :key="formIndex"
      :disableScroll="true"
      :showFooter="false"
      :title="titleModal"
    >
      <ZonasSeguridadForm
        :dataEdit="dataEdit"
        @successData="getSuccessData"
        @toggleModal="toggleModal"
      ></ZonasSeguridadForm>
    </modal>
  </div>
</template>

<script>
import ZonasSeguridadForm from "./ZonasSeguridadForm.vue";
import DataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "PuertasAcceso",
  components: {
    ZonasSeguridadForm,
    DataTable,
  },
  data() {
    return {
      areasSeguridad: [],

      formIndex: 1,
      showModal: false,
      dataEdit: [],
      editMode: false,

      titleModal: "",

      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "Areas de seguridad",
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addArea",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editArea",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteArea",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addArea") {
        this.titleModal = "Añadir Puerta de Area";
        this.showForm();
      }
      if (buttonId == "editArea") {
        this.titleModal = "Editar Puerta de Area";
        this.showEditForm(idSelected[0]);
      }
      if (buttonId == "deleteArea") {
        this.deleteArea(idSelected[0]);
      }
    },
    async getAreas() {
      this.areasSeguridad = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "SGD/Zonas"
        );

      if (snapshot.exists()) {
        let zonas = Object.entries(snapshot.val());
        zonas.forEach((element) => {
          this.areasSeguridad.push({ id: element[0], nm: element[1].nm });
        });
      }
    },

    showForm() {
      this.formIndex++;
      this.editMode = false;
      this.dataEdit = false;
      this.showModal = true;
    },
    showEditForm(id) {
      this.formIndex++;
      this.editMode = true;
      this.dataEdit = this.$pgsHelper.getById(this.areasSeguridad, "id", id);
      this.dataEdit.id = id;
      this.showModal = true;
    },

    toggleModal(open) {
      this.showModal = open;
    },
    getSuccessData(data) {
      let dataArea = {
        nm: data.nm,
      };

      if (data.edit == "" || !data.edit) {
        this.saveArea(dataArea);
      } else {
        dataArea.id = data.id;
        this.editArea(dataArea);
      }
    },

    saveArea(data) {
      this.$swal({
        title: "¿Deseas guardar esta Area de seguridad?",
        text: "La zona de seguridad se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("SGD-Zonas-createZona", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Puerta de acceso Guardada",
              "La puerta de acceso se almaceno correctamente",
              "success"
            );
            this.getAreas();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editArea(data) {
      const sendData = {
        nm: data.nm,
        Id: data.id,
      };
      this.$swal({
        title: "¿Deseas editar esta Area de seguridad?",
        text: "La Zona de seguridad se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("SGD-Zonas-updateZona", sendData)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Zona de seguridad Guardada",
              "La Zona de seguridad se actualizó correctamente",
              "success"
            );
            this.getAreas();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteAcceso(ID) {
      if (ID != "WEB" && ID != "GLOBAL") {
        let data = { Id: ID, force: true };
        data.Departamento = this.MainDepartamento;

        this.$swal({
          title: "¿Deseas eliminar esta Puerta de acceso?",
          text: "Se eliminará su información permanentemente",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            return await this.$store.getters.getFirebaseApp.fba
              .call("Alguna-Función", data)
              .then((result) => {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              this.$swal(
                "Puerta de acceso iliminada",
                "La Puerta de acceso se elimino correctamente",
                "success"
              );
            } else {
              this.$swal(
                "Error al guardar los datos",
                "No se guardaron los datos",
                "error"
              );
            }
          }
        });
      } else {
        this.$swal(
          "Error al guardar los datos",
          "No se puede eliminar LA Puerta de acceso " + ID,
          "error"
        );
      }
    },
  },
  async mounted() {
    await this.getAreas();
  },
};
</script>
